import { useState } from 'react'
import { useAuth } from '../../context/AuthContext'
import Autocomplete from '../Autocomplete'

const emptyEntry = { school: '', major: '', startYear: '', endYear: '', current: false }

function toYear(value) {
  const year = Number(value)
  return year > 0 ? year : undefined
}

function AcademicStep() {
  const { submitStep } = useAuth()
  const [entries, setEntries] = useState([{ ...emptyEntry }])
  const [error, setError] = useState('')
  const [submitting, setSubmitting] = useState(false)

  const updateEntry = (index, key, value) => {
    setEntries(entries.map((entry, i) => (i === index ? { ...entry, [key]: value } : entry)))
  }

  const addEntry = () => setEntries([...entries, { ...emptyEntry }])

  const removeEntry = (index) => setEntries(entries.filter((_, i) => i !== index))

  const save = async (payload) => {
    setError('')
    setSubmitting(true)
    try {
      await submitStep(payload)
    } catch (err) {
      setError(err.message)
      setSubmitting(false)
    }
  }

  const handleSubmit = (event) => {
    event.preventDefault()
    const education = entries
      .filter((entry) => entry.school.trim())
      .map((entry) => ({
        school: entry.school,
        major: entry.major,
        startYear: toYear(entry.startYear),
        endYear: entry.current ? undefined : toYear(entry.endYear),
        current: entry.current,
      }))
    save({ education })
  }

  return (
    <form className="onb-form" onSubmit={handleSubmit}>
      <h1 className="onb-title">Your education</h1>
      <p className="onb-sub">Add any degrees or programs. You can skip this.</p>

      {error && <div className="onb-error">{error}</div>}

      {entries.map((entry, index) => (
        <div className="onb-entry" key={index}>
          {entries.length > 1 && (
            <button type="button" className="onb-remove" onClick={() => removeEntry(index)}>
              Remove
            </button>
          )}
          <label className="onb-label">
            School
            <Autocomplete
              type="college"
              value={entry.school}
              onChange={(value) => updateEntry(index, 'school', value)}
              placeholder="Start typing..."
            />
          </label>
          <label className="onb-label">
            Major / field
            <input
              className="onb-input"
              value={entry.major}
              onChange={(event) => updateEntry(index, 'major', event.target.value)}
            />
          </label>
          <div className="onb-row">
            <label className="onb-label">
              Start year
              <input
                className="onb-input"
                type="number"
                value={entry.startYear}
                onChange={(event) => updateEntry(index, 'startYear', event.target.value)}
              />
            </label>
            <label className="onb-label">
              End year
              <input
                className="onb-input"
                type="number"
                value={entry.endYear}
                onChange={(event) => updateEntry(index, 'endYear', event.target.value)}
                disabled={entry.current}
              />
            </label>
          </div>
          <label className="onb-check">
            <input
              type="checkbox"
              checked={entry.current}
              onChange={(event) => updateEntry(index, 'current', event.target.checked)}
            />
            Currently studying here
          </label>
        </div>
      ))}

      <button type="button" className="onb-add" onClick={addEntry}>
        + Add another
      </button>

      <div className="onb-actions">
        <button type="button" className="onb-skip" onClick={() => save({ education: [] })} disabled={submitting}>
          Skip for now
        </button>
        <button type="submit" className="onb-submit" disabled={submitting}>
          {submitting ? 'Saving...' : 'Continue'}
        </button>
      </div>
    </form>
  )
}

export default AcademicStep
